import styled from '@emotion/styled';
import { useToggle } from 'ahooks';
import { Button, Card, Form, Input, Space } from 'antd';
import { useOrgValue, useOrgNameUpdater } from 'hooks/business/system/useOrg';
import { useTranslate } from '@tolgee/react';
import errorToaster from 'utils/errorToaster';

export interface CompanyFormProps {}

const TextButton = styled(Button)`
  padding: 0 0;
`;
const Flex = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 18px;
  > * {
    width: 28%;
  }
`;
const CompanyForm = (_props: CompanyFormProps) => {
  const { t } = useTranslate();
  const [isEditingOrg, { setLeft: cancelEditOrg, setRight: startEditOrg }] = useToggle(false);
  const orgInfo = useOrgValue();
  const orgNameUpdater = useOrgNameUpdater();
  return (
    <Form<{ orgName: string }>
      initialValues={orgInfo?.name ? { orgName: orgInfo?.name } : undefined}
      layout="vertical"
      onFinish={(values) => {
        return orgNameUpdater(values.orgName)
          .then((_rsp) => {
            cancelEditOrg();
            // return Promise.reject(new Error('hihihihi'))
          })
          .catch((e) => {
            errorToaster(e, '操作失败， 请稍后再试');
          });
      }}
    >
      {(_v, { setFieldsValue, getFieldValue }) => {
        const orgName = getFieldValue('orgName');
        return (
          <Card
            title={t('enterprise.企业信息')}
            extra={
              isEditingOrg ? (
                <Space size={24}>
                  <TextButton onClick={cancelEditOrg} type="link">
                    {t('enterprise.取消')}
                  </TextButton>
                  <TextButton htmlType="submit" type="link">
                    {t('enterprise.保存')}
                  </TextButton>
                </Space>
              ) : (
                <Button
                  onClick={() => {
                    startEditOrg();
                    setFieldsValue({ orgName: orgInfo?.name });
                  }}
                >
                  {t('enterprise.编辑信息')}
                </Button>
              )
            }
          >
            <Flex>
              {!isEditingOrg ? (
                <Space direction="vertical">
                  <div>{t('enterprise.公司名称')}</div>
                  <div>{orgName || '-'}</div>
                </Space>
              ) : (
                <Form.Item
                  required
                  rules={[{ required: true, message: t('enterprise.请填写公司名称') }]}
                  name="orgName"
                  label={t('enterprise.公司名称')}
                >
                  <Input />
                </Form.Item>
              )}
            </Flex>
          </Card>
        );
      }}
    </Form>
  );
};
export default CompanyForm;
